import { extractUserNames } from '@common/core/helpers/auth0-user'

import { addUserRegionalData, getUserRegionalData } from '../regional-user'
import type { InitializeRegionalInput, InitializeRegionalResult } from '../types'
import type { RegionalUser } from '../types/user.type'
import { addUserRegionalIdentity } from '../user'

export const addUserRegionalDataAndIdentity = async (
  input: InitializeRegionalInput,
  region: string,
  regionalData?: RegionalUser | null
): Promise<InitializeRegionalResult> => {
  let nextRegionalData = regionalData ?? null
  const { auth0User, currentUser } = input

  await addUserRegionalIdentity(region)

  if (!nextRegionalData) {
    const { email, firstName, lastName } = extractUserNames(auth0User, nextRegionalData)
    console.warn('Adding user regional data', { email, firstName, lastName })

    await addUserRegionalData({
      id: currentUser?.graftcodeUid ?? '',
      email,
      firstname: firstName,
      lastname: lastName,
      avatarUrl: null,
    })
    nextRegionalData = await getUserRegionalData()
  }

  return { regionalData: nextRegionalData, regionalIdentity: { userRegionalIdentityId: '', region: '', userUid: '' } }
}
